export default __webpack_public_path__ + "static/media/roadmap_1.648bfd7f.jpg";